/**
 * user-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { IncomingMessage } from "../general/";
import { MessageTag } from "../message-tag";
import { validateAs, validateFor, validateOpaqueID }
	from "../../validation/decorators";
import { GroupData } from "../../../auth/identity/group";
import { ZoneData } from "../../../auth/identity/zone";

export interface ExtendedUserData
{
	name : string;
	id : number;
	objectId: number;
	isCurrent : boolean;
	isActive : boolean;
	email : string;
	phone : string;
	"language code index" : number
	"country code index" : number
	groups : GroupData[];
	zones : ZoneData[];
}

@validateFor(MessageTag.RSP_USER)
export class UserResponse extends IncomingMessage implements ExtendedUserData
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.RSP_USER;
	public static tag : MessageTag = MessageTag.RSP_USER;

	@validateAs("string")
	public name : string;

	@validateOpaqueID()
	public objectId : number;

	@validateOpaqueID()
	public id : number;

	@validateAs("boolean")
	public isCurrent : boolean;

	@validateAs("boolean")
	public isActive : boolean;

	@validateAs("string")
	public email : string;
	@validateAs("string")
	public phone : string;

	@validateOpaqueID()
	public "language code index" : number;
	@validateOpaqueID()
	public "country code index" : number;

	@validateAs({"array": "object"})
	public groups : GroupData[];

	@validateAs({"array": "object"})
	public zones : ZoneData[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/user-response.ts